import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LangService {
  private languageChanged = new BehaviorSubject<string>('it');
  languageChanged$ = this.languageChanged.asObservable();

  private readonly supportedLangs = ['en', 'it'];
  private readonly fallbackLang = 'it';

  constructor(private translate: TranslateService) {
    this.translate.addLangs(this.supportedLangs);
  }

  setLang(language: string): string {
    const langToUse = this.supportedLangs.includes(language) ? language : this.fallbackLang;

    localStorage.setItem('language', langToUse);
    this.translate.use(langToUse);
    this.languageChanged.next(langToUse);

    return langToUse;
  }

  setDefaultLang(): string {
    localStorage.setItem('language', this.fallbackLang);
    this.translate.setDefaultLang(this.fallbackLang);
    this.translate.use(this.fallbackLang);
    this.languageChanged.next(this.fallbackLang);

    return this.fallbackLang;
  }
}
